import { Typography } from '@mui/material';
import styled from 'styled-components';
import { FlexCenter } from '../Flex';

export const TypeChip = styled(FlexCenter)`
  padding: 2px 6px;
  border-radius: 100px;
  border: 1px solid ${({ theme }) => theme.palette.common.black};
  width: fit-content;
`;

export const TypeChipLabel = styled(Typography)`
  font-size: 10px;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  line-height: normal;
`;
